var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagesReportJoyful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 470.325,
    height: 418.6,
    viewBox: "0 0 470.325 418.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages_Report_Joyful",
    "data-name": "Pages Report Joyful",
    transform: "translate(-257.236 -1743)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 166.1,
    cy: 32.1,
    rx: 166.1,
    ry: 32.1,
    transform: "translate(325.298 2097.4)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "data-source",
    transform: "translate(256.236 1739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M150.489,144.143a71.608,71.608,0,1,1,12.654-12.654l19.518,19.518,7.1-7.1a8.939,8.939,0,0,1,12.654,0L256.106,197.6a8.939,8.939,0,0,1,0,12.654l-26.847,26.847a8.939,8.939,0,0,1-12.654,0L162.91,183.412a8.939,8.939,0,0,1,0-12.654l7.1-7.1Zm31.4,32.942,41.041,41.041,14.193-14.193-41.041-41.041ZM106.593,33.9A53.695,53.695,0,1,1,52.9,87.593,53.726,53.726,0,0,1,106.593,33.9Z",
    transform: "translate(207.594 50.269)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 10,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle6",
    d: "M54.393,18.7A7.7,7.7,0,1,1,46.7,11,7.7,7.7,0,0,1,54.393,18.7Z",
    transform: "translate(234.38 26.786)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M38.7,26.392H69.483a7.7,7.7,0,0,0,0-15.393H38.7a7.7,7.7,0,0,0,0,15.393Z",
    transform: "translate(180.805 26.78)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M327.257,299.47h84.662a7.7,7.7,0,0,1,7.7,7.7V345.65a46.177,46.177,0,0,1-46.18,46.18H127.145a46.091,46.091,0,0,1-46.18-46.087V99.359H11.7a7.7,7.7,0,0,1-7.7-7.7V53.087A46.091,46.091,0,0,1,50.087,7h230.99a46.17,46.17,0,0,1,46.18,46.18,7.7,7.7,0,1,1-15.393,0,30.8,30.8,0,0,0-30.786-30.786H84.653A46.083,46.083,0,0,1,96.359,53.087V345.742a30.692,30.692,0,0,0,30.694,30.694h.185a30.692,30.692,0,0,0,30.694-30.694V307.167a7.7,7.7,0,0,1,7.7-7.7H311.863V222.5a7.7,7.7,0,0,1,15.393,0Zm76.966,15.393h-230.9v30.879a46.083,46.083,0,0,1-11.707,30.694H373.436a30.788,30.788,0,0,0,30.786-30.786ZM80.966,83.966V53.087A30.692,30.692,0,0,0,50.272,22.393h-.185A30.692,30.692,0,0,0,19.393,53.087V83.966Z",
    transform: "translate(0 0)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M65.18,22.7a7.7,7.7,0,0,0-7.7-7.7H26.7A7.7,7.7,0,0,0,19,22.7v200.11a7.7,7.7,0,0,0,7.7,7.7H57.483a7.7,7.7,0,0,0,7.7-7.7ZM34.394,30.391V215.109H49.787V30.391Z",
    transform: "translate(100.452 53.566)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M73.18,32.7a7.7,7.7,0,0,0-7.7-7.7H34.7A7.7,7.7,0,0,0,27,32.7V155.843a7.7,7.7,0,0,0,7.7,7.7H65.483a7.7,7.7,0,0,0,7.7-7.7ZM42.394,40.392V148.145H57.787V40.392Z",
    transform: "translate(154.025 120.538)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M81.18,42.7a7.7,7.7,0,0,0-7.7-7.7H42.7A7.7,7.7,0,0,0,35,42.7V88.876a7.7,7.7,0,0,0,7.7,7.7H73.483a7.7,7.7,0,0,0,7.7-7.7Zm-30.786,7.7V81.179H65.787V50.394Z",
    transform: "translate(207.598 187.504)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622",
    transform: "translate(-237.585 -182.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6820",
    "data-name": "Path 6820",
    d: "M169.868,224.853a3.348,3.348,0,0,0-4.729.262,37.261,37.261,0,0,1-55.3,0,3.349,3.349,0,1,0-4.99,4.468,43.958,43.958,0,0,0,65.276,0A3.352,3.352,0,0,0,169.868,224.853Z",
    transform: "translate(415.014 112.459)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6821",
    "data-name": "Path 6821",
    d: "M224.746,128A16.765,16.765,0,0,0,208,144.746a3.349,3.349,0,0,0,6.7,0,10.048,10.048,0,1,1,20.1,0,3.349,3.349,0,1,0,6.7,0A16.765,16.765,0,0,0,224.746,128Z",
    transform: "translate(354.553 168.268)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6822",
    "data-name": "Path 6822",
    d: "M106.793,144.746a3.349,3.349,0,1,0,6.7,0,16.746,16.746,0,1,0-33.492,0,3.349,3.349,0,1,0,6.7,0,10.048,10.048,0,0,1,20.1,0Z",
    transform: "translate(428.966 168.268)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesReportJoyful);
export default __webpack_public_path__ + "static/media/pages-report-joyful.c91a90149120f4550fb36fe6e1b1600a.svg";
export { ForwardRef as ReactComponent };